import { deepExtract } from 'helpers/deep';

const key = 'features.dynamicTags';

const SET_TAGS = `${key}.SET_TAGS`;
const SET_URLS_BY_TAG_ID = `${key}.SET_URLS_BY_TAG_ID`;

export const setTags = tags => ({ type: SET_TAGS, data: { tags } });
export const setUrlsByTagId = urlsByTagId => ({ type: SET_URLS_BY_TAG_ID, data: { urlsByTagId } });

const initialState = {
  tags: {},
  urlsByTagId: {},
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_TAGS:
    case SET_URLS_BY_TAG_ID:
      return { ...state, ...action.data };
    default:
      return state;
  }
}

export const selectTags = state => deepExtract(`${key}.tags`, state);
export const selectUrlsByTagId = state => deepExtract(`${key}.urlsByTagId`, state);
